import type { LeadSource } from "@/lib/lead-types";

const UTM_PARAMS = [
  ["utm_source", "utmSource"],
  ["utm_medium", "utmMedium"],
  ["utm_campaign", "utmCampaign"],
  ["utm_content", "utmContent"],
  ["utm_term", "utmTerm"],
] as const;

/**
 * Reads the campaign that brought the visitor here so the lead row carries its
 * own attribution and sales does not need to cross-reference analytics.
 */
export function readLeadSource(): LeadSource {
  if (typeof window === "undefined") return {};

  const params = new URLSearchParams(window.location.search);
  const source: LeadSource = {};

  for (const [param, key] of UTM_PARAMS) {
    const value = params.get(param)?.trim();
    if (value) source[key] = value.slice(0, 200);
  }

  const referrer = document.referrer.trim();
  if (referrer && !referrer.startsWith(window.location.origin)) {
    source.referrer = referrer.slice(0, 500);
  }

  return source;
}
